import fromEntries from 'fromentries';

const decodeCookie = (cookieString) => {
    return decodeURIComponent(cookieString);
};
const parseCookie = (cookie, decode = decodeCookie) => {
    return fromEntries(cookie.split(/; */).map((c) => {
        const [key, ...v] = c.split('=');
        return [key, decode(v.join('='))];
    }));
};
const getCsrfCookie = (cookieString) => {
    const cookies = parseCookie(cookieString, (cookieString) => cookieString);
    const identCookieName = Object.keys(cookies).find((cookieName) => cookieName.endsWith('ITKT'));
    if (identCookieName) {
        return cookies[identCookieName];
    }
};
const getCsrfTokenHeader = (cookieValue) => {
    const cookie = getCsrfCookie(cookieValue);
    if (cookie) {
        return { 'X-CSRF-TOKEN': cookie };
    }
    return {};
};
const setCookie = ({ name, value, expires, domain, }) => {
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; ${domain ? `domain=${domain};` : ''} path=/; secure;`;
};
const getCookie = (cookieKey) => {
    const cookieName = `${cookieKey}=`;
    const cookieParts = document.cookie.split(';');
    for (let cookie of cookieParts) {
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.indexOf(cookieName) === 0) {
            return decodeURIComponent(cookie.substring(cookieName.length, cookie.length));
        }
    }
};
const getExpiryDate = (expiryDays) => {
    const dateNow = new Date();
    const expiryDate = new Date(dateNow.toUTCString());
    expiryDate.setDate(dateNow.getDate() + expiryDays);
    return expiryDate.toUTCString();
};

export { getCookie, getCsrfCookie, getCsrfTokenHeader, getExpiryDate, parseCookie, setCookie };
//# sourceMappingURL=cookie.js.map
